import { gql, LazyQueryHookOptions, useLazyQuery } from '@apollo/client';
import {
  GetAppConfigurationsQuery,
  GetAppConfigurationsQueryVariables,
} from '../../../shared/generated/graphql';

export const GET_APP_CONFIGURATIONS = gql`
  query getAppConfigurations {
    getAppConfigurations {
      body {
        data
        message
        success
      }
      status_code
    }
  }
`;

export const useGetAppConfigurations = (
  options?: LazyQueryHookOptions<
    GetAppConfigurationsQuery,
    GetAppConfigurationsQueryVariables
  >,
) => {
  return useLazyQuery<
    GetAppConfigurationsQuery,
    GetAppConfigurationsQueryVariables
  >(GET_APP_CONFIGURATIONS, {
    notifyOnNetworkStatusChange: true,
    ...options,
  });
};
